import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/forms/auth/signin/signin-new-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsContent"] */ "/app/src/components/ui/tabs.tsx");
